




























import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import FieldWrapper from '../field-wrapper/field-wrapper.vue';
import AbstractField from '@/app/modules/shared/components/forms/inputs/abstract-field/abstract-field';
import TableMock from '@shared/components/mocks/table-mock/table-mock.vue';
import { v4 as uuidv4 } from 'uuid';
import MembershipList from '@subscriptions/components/lists/admin/membership-list.vue';
import ContentWrapper from '@shared/layouts/wrappers/content-wrapper.vue';
import { BPCTableField } from '@shared/interfaces/bpc-table-interface';

@Component({
  name: 'bpc-membership-table-input',
  components: {
    'bpc-field-wrapper': FieldWrapper,
    'bpc-table-mock': TableMock,
    'bpc-content-wrapper': ContentWrapper,
    'bpc-membership-list': MembershipList,
  },
})
export default class MembershipTableInput extends mixins(AbstractField) {
  // Props
  @Prop({ type: Boolean, default: true }) readonly showCreateButton: boolean;
  @Prop({ type: Boolean, default: false }) readonly withUrlParams: boolean;
  @Prop({ type: Boolean, default: false }) readonly showCategoryFilter: boolean;

  // Data
  tableFields: BPCTableField[] = [
    {
      key: 'membership_category.name',
      headerLabel: 'global.membership.membership_category.header_label',
      order: 0,
    },
    {
      key: 'start_date',
      headerLabel: 'global.subscription.start_date.header_label',
      order: 1,
    },
    {
      key: 'end_date',
      headerLabel: 'global.subscription.end_date.header_label',
      order: 2,
    },
    {
      key: 'status',
      headerLabel: `global.status.label`,
      order: 3,
    },
    {
      key: 'paid_amount',
      headerLabel: 'subscriptions.membership.paid_amount.header_label',
      order: 4,
    },
    {
      key: 'balance',
      headerLabel: 'subscriptions.membership.balance.header_label',
      order: 5,
    },
    {
      key: 'price',
      headerLabel: 'global.subscription.subscription_price.label',
      order: 6,
    },
    {
      key: 'payment_status',
      headerLabel: '',
      order: 7,
    },
  ];

  // Computed

  // Lifecycle hooks
  // mounted() {
  // }

  // Methods
  get actionsPortalTarget() {
    return `memberships-actions-${uuidv4()}`;
  }

  // Watchers
}
